export default "__VITE_ASSET__C8eWxI5j__"